export default __webpack_public_path__ + "static/media/collapse-close.963da736.svg";